/**
 * Invite cards arrive in message content written by other clients, so their
 * `path` is untrusted. Only same-origin in-app routes under `/games/` may be
 * navigated to — never an absolute URL, a protocol-relative `//host`, a
 * `javascript:` URL, or a `..` walk out of the games area.
 */
const BASE = "https://invite.invalid";

/** The normalised in-app path, or null when `path` isn't a safe games route. */
export function safeInvitePath(path: unknown): string | null {
  if (typeof path !== "string" || !path.startsWith("/games/")) return null;
  // Browsers read `\` as `/` and drop tabs/newlines while parsing a URL.
  if (/[\\\s\u0000-\u001f\u007f]/.test(path)) return null;

  let url: URL;
  try {
    url = new URL(path, BASE);
  } catch {
    return null;
  }
  if (url.origin !== BASE || !url.pathname.startsWith("/games/")) return null;
  return `${url.pathname}${url.search}${url.hash}`;
}

/** What a game calls its room on the invite card — Card Table seats a table. */
export function inviteRoomNoun(game: string): string {
  return game === "tabletop" ? "Table" : "Room";
}
